import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Breadcrumbs from '../../molecules/Breadcrumbs';
import Footer from '../../molecules/Footer';

const Layout = styled.div`
  font-family: Hind, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 40px 8px 16px;
`;

const BreadcrumbsWrapper = styled.div`
  padding: 15px 40px 8px 16px;

  .ant-breadcrumb {
    padding: 20px;
  }
`;

const FooterWrapper = styled.div`
  filter: drop-shadow(1px -1px 3px #d4d4d4);
  background: rgba(255, 255, 255, 0.75);
`;

function Default({ breadcrumbs, children, footer }) {
  return (
    <Layout>
      <BreadcrumbsWrapper>{breadcrumbs}</BreadcrumbsWrapper>
      <Content>{children}</Content>
      <FooterWrapper>{footer}</FooterWrapper>
    </Layout>
  );
}

Default.propTypes = {
  breadcrumbs: PropTypes.node,
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
};

Default.defaultProps = {
  breadcrumbs: <Breadcrumbs />,
  footer: <Footer />,
};

export default Default;
